module.exports = __webpack_public_path__ + "img/logo-icinga.6890dd9a.svg";